<script>
	import Button from '../Button/Button.svelte';
	import Icon from '../Icon/Icon.svelte';
	import SourceBadges from '../SourceBadges/SourceBadges.svelte';

	/** @type {String} */
	export let description;
	/** @type {String} */
	export let title;
	/** @type {{ href: string; iconName: string; label: string; kind: string;}[]} */
	export let desktopCtas;
	/** @type {String} */
	export let desktopImage;
	/** @type {{ href: string; iconName: string; label: string; kind: string;}[]} */
	export let mobileCtas;
	/** @type {String} */
	export let mobileCtasLabel;
	/** @type {String} */
	export let mobileImage;
	/** @type {String} */
	export let imageAlt;

	/** @type {number} */
	let innerWidth;
</script>

<svelte:window bind:innerWidth />

<div class="hero-banner">
	<div class="copy">
		<span class="title">
			{@html title}
		</span>

		<span class="description">
			{@html description}
		</span>

		<SourceBadges />

		{#if mobileCtas?.length}
			<div class="actions-box mobile">
				<span>{mobileCtasLabel}</span>

				{#each mobileCtas as cta}
					{#if cta.iconName}
						<Button {...cta}>
							{cta.label}
							<Icon name={cta.iconName} --size="1.25rem" slot="right" />
						</Button>
					{:else}
						<Button {...cta}>
							{cta.label}
						</Button>
					{/if}
				{/each}
			</div>
		{/if}

		{#if desktopCtas?.length}
			<div class="actions-box desktop">
				{#each desktopCtas as cta}
					{#if cta.iconName}
						<Button {...cta}>
							{cta.label}
							<Icon name={cta.iconName} --size="1.25rem" slot="right" />
						</Button>
					{:else}
						<Button {...cta}>
							{cta.label}
						</Button>
					{/if}
				{/each}
			</div>
		{/if}
	</div>

	<div class="media">
		<slot name="media">
			<picture>
				<source srcset={mobileImage} media="(max-width: 600px)" />
				<source srcset={desktopImage} media="(min-width: 601px)" />
				<img class="hero-image" src={mobileImage ?? desktopImage} alt={imageAlt} />
			</picture>
		</slot>
	</div>
</div>

<style>.hero-banner{display:grid;align-items:center;grid-gap:3.5rem;gap:3.5rem;max-width:var(--max-width);margin:auto;padding:2rem 1rem}@media (min-width:767.02px){.hero-banner{padding:3rem 1rem;grid-template-columns:1fr 1fr}}.copy{display:flex;flex-direction:column;justify-content:flex-start;gap:1.5rem}@media (max-width:767px){.copy{justify-content:center;align-items:center;text-align:center}}.actions-box{display:grid;grid-gap:1rem;gap:1rem;min-width:14rem;padding-top:.5rem;padding-bottom:.5rem}@media (max-width:767px){.actions-box{align-items:center!important;justify-items:center!important;place-items:center!important;align-content:center!important;justify-content:center!important;place-content:center!important}.actions-box.desktop{display:none}}@media (min-width:767.02px){.actions-box{padding-top:1rem;padding-bottom:1rem;justify-items:flex-start;justify-content:flex-start}.actions-box.mobile{display:none}}.actions-box span{font:var(--f-ui-md-semibold)}.hero-banner :global(h1){font:var(--f-heading-lg-semibold)}@media (min-width:767.02px){.hero-banner :global(h1){font:var(--f-heading-xxl-bold)}.hero-banner :global(.source-badges){justify-content:flex-start}.hero-banner :global(.source-badges) :global(span){font:var(--f-ui-sm-semibold)}}.hero-banner :global(p){font:var(--f-paragraph-sm-medium)}@media (min-width:767.02px){.hero-banner :global(p){font:var(--f-paragraph-lg-medium)}}@media (max-width:480px){.hero-banner :global(p) :global(br){display:none}}.hero-banner :global(p) :global(strong){font-weight:bolder}.hero-banner :global(strong){color:hsla(var(--hsl-primary))}</style>
